import styled from '@emotion/styled';


// export const SidebarContainer = styled.aside
//   width: ${({ isExpanded }) => isExpanded ? '240px' : '64px'};
//   height: 100%;
//   background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
//   position: relative;
//   transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//   overflow: hidden;
//   border-right: 1px solid #e5e7eb;
// ;


// 🎨 옵션 1: 기본 투명 보라색 테두리
// export const SidebarContainer = styled.aside`
//   width: ${({ isExpanded }) => isExpanded ? '240px' : '64px'};
//   height: 100%;
//   background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
//   position: relative;
//   transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//   overflow: hidden;
//   border-right: 1px solid rgba(124, 58, 237, 0.2);
// `;

// 🌈 옵션 2: 그라데이션 테두리 효과
// export const SidebarContainer = styled.aside`
//   width: ${({ isExpanded }) => isExpanded ? '240px' : '64px'};
//   height: 100%;
//   background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
//   position: relative;
//   transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//   overflow: hidden;
//   border-right: 2px solid;
//   border-image: linear-gradient(180deg, rgba(124, 58, 237, 0.4) 0%, rgba(124, 58, 237, 0.1) 100%) 1;
// `;

// ✨ 옵션 3: 박스 섀도우로 부드러운 경계
// export const SidebarContainer = styled.aside`
//   width: ${({ isExpanded }) => isExpanded ? '240px' : '64px'};
//   height: 100%;
//   background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
//   position: relative;
//   transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//   overflow: hidden;
//   box-shadow: 2px 0 8px rgba(124, 58, 237, 0.1);
// `;

// 🔮 옵션 4: 다중 섀도우로 글로우 효과
export const SidebarContainer = styled.aside`
  width: ${({ isExpanded }) => isExpanded ? '240px' : '64px'};
  height: 100%;
  background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
  position: relative;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  box-shadow: 
    1px 0 2px rgba(124, 58, 237, 0.1),
    2px 0 4px rgba(124, 58, 237, 0.08),
    3px 0 8px rgba(118, 44, 246, 0.06);
`;

// 🎭 옵션 5: 테두리 + 미세한 내부 섀도우 조합
// export const SidebarContainer = styled.aside`
//   width: ${({ isExpanded }) => isExpanded ? '240px' : '64px'};
//   height: 100%;
//   background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
//   position: relative;
//   transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//   overflow: hidden;
//   border-right: 1px solid rgba(124, 58, 237, 0.15);
//   box-shadow: inset -1px 0 0 rgba(124, 58, 237, 0.05);
// `;

// 🌟 옵션 6: 호버 효과가 있는 동적 테두리
// export const SidebarContainer = styled.aside`
//   width: ${({ isExpanded }) => isExpanded ? '240px' : '64px'};
//   height: 100%;
//   background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
//   position: relative;
//   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//   overflow: hidden;
//   border-right: 1px solid rgba(124, 58, 237, 0.2);
  
//   &:hover {
//     border-right-color: rgba(124, 58, 237, 0.4);
//     box-shadow: 2px 0 12px rgba(124, 58, 237, 0.08);
//   }
// `;

export const ToggleButton = styled.button`
  position: absolute;
  top: 12px;
  right: ${({ isExpanded }) => isExpanded ? '16px' : '12px'};
  width: 40px;
  height: 40px;
  background: rgba(124, 58, 237, 0.1);
  border: 1px solid rgba(124, 58, 237, 0.2);
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 100;
  
  &:hover {
    background: rgba(124, 58, 237, 0.15);
    border-color: rgba(124, 58, 237, 0.3);
  }
`;

export const ToggleIcon = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7C3AED;
  font-size: 14px;
  transition: transform 0.3s ease;
  
  &::before {
    content: ${({ isExpanded }) => isExpanded ? '"‹"' : '"<"'};
    transform: ${({ isExpanded }) => isExpanded ? 'none' : 'scaleX(-1)'};
  }
`;

export const SidebarHeader = styled.header`
  padding: ${({ isExpanded }) => isExpanded ? '17px 56px 0 16px' : '17px 8px 0 8px'};
  transition: padding 0.3s ease;
`;

// 새로운 로고 스타일들
export const LogoOption = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  opacity: 1;
  transition: opacity 0.2s ease;
`;

export const LogoTitle = styled.div`
  color: #7C3AED;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  margin: 0;
`;

export const LogoSvg = styled.svg`
  width: 140px;
  height: 35px;
  margin: 4px 0;
`;

export const LogoDescription = styled.div`
  color: #9333EA;
  font-family: "Inter", sans-serif;
  font-size: 10px;
  line-height: 14px;
  font-weight: 400;
  margin: 0;
  opacity: 0.8;
`;

export const CollapsedLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 29px;
`;

export const CollapsedLogoSvg = styled.svg`
  width: 24px;
  height: 24px;
`;

export const Navigation = styled.nav`
  position: absolute;
  top: 80px;
  left: 0px;
  right: 0px;
  bottom: ${({ isExpanded }) => isExpanded ? '120px' : '100px'};
  width: 100%;
  height: calc(100% - 120px - ${({ isExpanded }) => isExpanded ? '120px' : '100px'});
  overflow: hidden;
  transition: bottom 0.3s ease;
`;

export const NavTitle = styled.h2`
  color: #7C3AED;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  line-height: 17px;
  font-weight: 500;
  margin: 16px 16px 9px;
  height: 15px;
  display: flex;
  align-items: center;
  opacity: 0.8;
  transition: opacity 0.2s ease;
`;

export const NavList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0 8px;
`;

export const NavItem = styled.li`
  width: 100%;
  height: 40px;
  border-radius: 6px;
  background: ${({ isActive }) => isActive ? 'rgba(124, 58, 237, 0.15)' : 'transparent'};
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  padding: ${({ isExpanded }) => isExpanded ? '0 8px' : '0'};
  cursor: pointer;
  transition: all 0.2s ease;
  justify-content: ${({ isExpanded }) => isExpanded ? 'flex-start' : 'center'};
  position: relative;
  
  &:hover {
    background: rgba(124, 58, 237, 0.1);
  }
  
  /* 접힌 상태에서 호버 시 툴팁 효과 */
  ${({ isExpanded }) => !isExpanded && `
    &:hover::after {
      content: attr(title);
      position: absolute;
      left: 60px;
      top: 50%;
      transform: translateY(-50%);
      background: rgba(0, 0, 0, 0.8);
      color: white;
      padding: 4px 8px;
      border-radius: 4px;
      font-size: 12px;
      white-space: nowrap;
      z-index: 1000;
      pointer-events: none;
    }
  `}
`;

export const NavIcon = styled.div`
  width: 20px;
  height: 20px;
  margin-right: ${({ isExpanded }) => isExpanded ? '12px' : '0'};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  
  ${({ type }) => {
    if (type === 'upload') {
      return `&::before { content: '📁'; font-size: 16px; }`;
    } else if (type === 'edit') {
      return `&::before { content: '✏️'; font-size: 16px; }`;
    } else if (type === 'report') {
      return `&::before { content: '📊'; font-size: 16px; }`;
    }
  }}
`;

export const NavText = styled.span`
  color: #7C3AED;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 17px;
  font-weight: 400;
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const UserSection = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: ${({ isExpanded }) => isExpanded ? '80px' : '100px'};
  border-top: 1px solid #e5e7eb;
  padding: ${({ isExpanded }) => isExpanded ? '17px 16px 0' : '12px 8px 0'};
  transition: all 0.3s ease;
  background: rgba(249, 250, 251, 0.5);
`;

export const UtilityButtons = styled.div`
  display: flex;
  gap: 32px;
  margin-bottom: 12px;
`;

export const UtilityButton = styled.button`
  width: 48px;
  height: 36px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 0.7;
  }
  
  ${({ type }) => {
    if (type === 'settings') {
      return `&::before { content: '⚙️'; font-size: 20px; }`;
    } else if (type === 'notification') {
      return `&::before { content: '🔔'; font-size: 20px; }`;
    } else if (type === 'help') {
      return `&::before { content: '❓'; font-size: 20px; }`;
    }
  }}
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const UserAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background: rgba(124, 58, 237, 0.1);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 1px solid rgba(124, 58, 237, 0.2);
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const AvatarPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7C3AED;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
`;

export const UserDetails = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const UserName = styled.span`
  color: #7C3AED;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 17px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const UserDepartment = styled.span`
  color: rgba(124, 58, 237, 0.7);
  font-family: "Inter", sans-serif;
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const LogoutButton = styled.button`
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;
  border-radius: 4px;
  flex-shrink: 0;
  
  &:hover {
    opacity: 0.7;
    background: rgba(124, 58, 237, 0.1);
  }
  
  &::before {
    content: 'Logout';
    font-size: 16px;
    color: #7C3AED;
  }
`;

/* 접힌 상태 스타일 */
export const CollapsedUserSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
`;

export const CollapsedUtilityButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  align-items: center;
`;

export const CollapsedUtilityButton = styled.button`
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  border-radius: 4px;
  position: relative;
  
  &:hover {
    background: rgba(124, 58, 237, 0.1);
  }
  
  /* 호버 시 툴팁 */
  &:hover::after {
    content: attr(title);
    position: absolute;
    left: 40px;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 1000;
    pointer-events: none;
  }
  
  ${({ type }) => {
    if (type === 'settings') {
      return `&::before { content: '⚙️'; font-size: 16px; }`;
    } else if (type === 'notification') {
      return `&::before { content: '🔔'; font-size: 16px; }`;
    } else if (type === 'help') {
      return `&::before { content: '❓'; font-size: 16px; }`;
    }
  }}
`;

export const CollapsedUserInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const CollapsedLogoutButton = styled.button`
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  border-radius: 4px;
  position: relative;
  
  &:hover {
    background: rgba(124, 58, 237, 0.1);
  }
  
  /* 호버 시 툴팁 */
  &:hover::after {
    content: attr(title);
    position: absolute;
    left: 40px;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 1000;
    pointer-events: none;
  }
  
  &::before {
    content: 'Logout';
    font-size: 16px;
    color: #7C3AED;
  }
`;

export const LogoImage = styled.img`
  width: 100px;
  height: 40px;
  object-fit: contain;
  ${({ isCollapsed }) => isCollapsed && `
    width: 24px;
    height: 24px;
  `}
`;
